import configureStore from './storeTermine'
const store = configureStore({})
export default store


// WEBPACK FOOTER //
// ./src/TermineStore.js